import { lazy } from "react";

const DashboardPage = lazy(() => import("./pages/organization/DashboardPage"));
const OrganizationPage = lazy(
  () => import("./pages/organization/OrganizationPage"),
);
const ReportPage = lazy(() => import("./pages/organization/ReportPage"));
const Units = lazy(() => import("./pages/master/Units"));
const Employees = lazy(() => import("./pages/master/Employees"));
const CountryPage = lazy(() => import("./pages/master/Country"));
const ContainerTypePage = lazy(() => import("./pages/master/ContainerType"));
const StatesPage = lazy(() => import("./pages/master/States"));
const CurrencyPage = lazy(() => import("./pages/master/Currency"));
const PackageTypePage = lazy(() => import("./pages/master/PackageType"));
const CityPage = lazy(() => import("./pages/master/City"));
const PaymentTermsPage = lazy(() => import("./pages/master/PaymentTerms"));
const PortsPage = lazy(() => import("./pages/master/Ports"));
const CustomersPage = lazy(() => import("./pages/master/Customers"));
const ProductPage = lazy(() => import("./pages/organization/Products"));
const QuotationDocumentPage = lazy(() => import("./pages/organization/QuotationDocument"));
const PerformaDocumentPage = lazy(() => import("./pages/organization/PerformaDocument"));
const InvoiceDocumentPage = lazy(() => import("./pages/organization/InvoiceDocument"));
const BLDraftDocumentPage = lazy(() => import("./pages/organization/BLDraftDocument"));
const PackageListingDocumentPage = lazy(() => import("./pages/organization/PackageListingDocument"));
const VgmDocumentPage = lazy(() => import("./pages/organization/VgmDocument"));
const AnnexureDocumentPage = lazy(() => import("./pages/organization/AnnexureDocument"));
const SupportPage = lazy(() => import("./pages/organization/SupportPage"));
const BillingPage = lazy(() => import("./pages/organization/BillingPage"));

const routes = [
  { route: "/dashboard", element: DashboardPage, layout: true },
  { route: "/organization", element: OrganizationPage, layout: true },
  { route: "/billing", element: BillingPage, layout: true },
  { route: "/reports", element: ReportPage, layout: true },
  { route: "/units", element: Units, layout: true },
  { route: "/employees", element: Employees, layout: true },
  { route: "/country", element: CountryPage, layout: true },
  { route: "/containerType", element: ContainerTypePage, layout: true },
  { route: "/states", element: StatesPage, layout: true },
  { route: "/currency", element: CurrencyPage, layout: true },
  { route: "/packageType", element: PackageTypePage, layout: true },
  { route: "/city", element: CityPage, layout: true },
  { route: "/paymentTerms", element: PaymentTermsPage, layout: true },
  { route: "/ports", element: PortsPage, layout: true },
  { route: "/customers", element: CustomersPage, layout: true },
  { route: "/products", element: ProductPage, layout: true },
  { route: "/products/add", element: ProductPage, layout: true },
  { route: "/products/edit/:id", element: ProductPage, layout: true },
  { route: "/quotation-documents", element: QuotationDocumentPage, layout: true },
  { route: "/quotation-documents/add", element: QuotationDocumentPage, layout: true },
  { route: "/quotation-documents/edit/:id", element: QuotationDocumentPage, layout: true },
  { route: "/performa-documents", element: PerformaDocumentPage, layout: true },
  { route: "/performa-documents/add", element: PerformaDocumentPage, layout: true },
  { route: "/performa-documents/edit/:id", element: PerformaDocumentPage, layout: true },
  { route: "/invoice-documents", element: InvoiceDocumentPage, layout: true },
  { route: "/invoice-documents/add", element: InvoiceDocumentPage, layout: true },
  { route: "/invoice-documents/edit/:id", element: InvoiceDocumentPage, layout: true },
  { route: "/bl-draft-documents", element: BLDraftDocumentPage, layout: true },
  { route: "/bl-draft-documents/add", element: BLDraftDocumentPage, layout: true },
  { route: "/bl-draft-documents/edit/:id", element: BLDraftDocumentPage, layout: true },
  { route: "/package-listing-documents", element: PackageListingDocumentPage, layout: true },
  { route: "/vgm-documents", element: VgmDocumentPage, layout: true },
  { route: "/vgm-documents/add", element: VgmDocumentPage, layout: true },
  { route: "/vgm-documents/edit/:id", element: VgmDocumentPage, layout: true },
  { route: "/annexure-documents", element: AnnexureDocumentPage, layout: true },
  { route: "/annexure-documents/add", element: AnnexureDocumentPage, layout: true },
  { route: "/annexure-documents/edit/:id", element: AnnexureDocumentPage, layout: true },
  { route: "/support", element: SupportPage, layout: true },
];

export default routes;
